/*const hostname = window.location.hostname;

export const API_BASE_URL =
  hostname === 'localhost'
    ? 'http://localhost:5000'
    : `http://${hostname}:5000`; // auto-detect IP from browser
*/

export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (window.location.hostname === 'localhost'
    ? 'http://localhost:5000'
    : `http://${window.location.hostname}:5000`);
